import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  size: string | null;
  price: string | number;
  currency?: 'usd' | 'eur';
}


import { computed } from 'vue';
import type { StyleValue } from 'vue/types/jsx';

declare module 'vue/types/vue' {
  export interface Vue {
    DisplayPrice: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'DisplayPrice' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    size: null,
    price: null,
    currency: { default: 'usd' }
  },
  setup(__props: any) {

const props = __props as { size: string | null, price: string | number, currency: 'usd' | 'eur' };

/**
 * `DisplayPrice` component properties.
 */


const style = computed(() => {
  const style: StyleValue = {};

  if (props.size) {
    style.fontSize = props.size;
  }

  return style;
});

const amount = computed(() => {
  const amount = parseFloat(props.price.toString());

  if (isNaN(amount) || amount < 0) {
    throw new Error('[]');
  }

  return amount;
});

const isFree = computed(() => {
  return amount.value === 0;
});

const displayPrice = computed(() => {
  const [dollars, change] = amount.value
    .toLocaleString('en-US', {
      style: 'currency',
      currency: props.currency,
    })
    .split('.');

  return { dollars, change };
});

return { __sfc: true,props, style, amount, isFree, displayPrice }
}

})